import { render, staticRenderFns } from "./OrigenFormulario.vue?vue&type=template&id=338475ca&scoped=true"
import script from "./OrigenFormulario.vue?vue&type=script&lang=js"
export * from "./OrigenFormulario.vue?vue&type=script&lang=js"
import style0 from "./OrigenFormulario.vue?vue&type=style&index=0&id=338475ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338475ca",
  null
  
)

export default component.exports